{
  "name": "dive_ops",
  "version": "1.0.12",
  "author": "Ionic Framework",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest --no-cache",
    "test-esm": "node --experimental-vm-modules --no-warnings node_modules/jest/bin/jest.js -c=jest-esm.config.mjs --no-cache",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "lint": "ng lint",
    "e2e": "playwright test",
    "e2e:headed": "playwright test --headed",
    "e2e:smoke": "playwright test --grep @smoke",
    "e2e:regression": "playwright test --grep @regression",
    "e2e:stress": "playwright test --grep @stress",
    "e2e:report": "playwright show-report",
    "version:patch": "node scripts/bump-version.mjs patch",
    "version:minor": "node scripts/bump-version.mjs minor",
    "version:major": "node scripts/bump-version.mjs major",
    "play:upload": "node scripts/upload-google-play.mjs",
    "play:upload:dry-run": "node scripts/upload-google-play.mjs --dry-run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "17.3.12",
    "@angular/common": "17.3.12",
    "@angular/compiler": "17.3.12",
    "@angular/core": "17.3.12",
    "@angular/forms": "17.3.12",
    "@angular/platform-browser": "17.3.12",
    "@angular/platform-browser-dynamic": "17.3.12",
    "@angular/router": "17.3.12",
    "@angular/service-worker": "17.3.12",
    "@capacitor-community/file-opener": "^6.0.0",
    "@capacitor/android": "^6.1.0",
    "@capacitor/app": "^6.0.0",
    "@capacitor/cli": "^6.1.2",
    "@capacitor/filesystem": "^6.0.0",
    "@capacitor/ios": "^6.1.0",
    "@capacitor/network": "^6.0.1",
    "@capacitor/share": "^6.0.4",
    "@ionic/angular": "^7.8.6",
    "@ngrx/effects": "^17.2.0",
    "@ngrx/entity": "^17.2.0",
    "@ngrx/operators": "^17.2.0",
    "@ngrx/store": "^17.2.0",
    "@ngrx/store-devtools": "^17.2.0",
    "@sentry/angular": "^8.7.0",
    "@sentry/cli": "^2.21.2",
    "@sentry/tracing": "^7.73.0",
    "array-sort-by": "^1.2.1",
    "base64-js": "^1.5.1",
    "date-fns": "^2.28.0",
    "ionic-selectable": "^5.0.3",
    "ionicons": "^7.4.0",
    "iter-ops": "^1.6.2",
    "lodash": "^4.17.21",
    "ngrx-forms": "^8.0.0",
    "pouchdb": "^7.2.2",
    "rxjs": "~7.8.0",
    "signature_pad": "^5.0.1",
    "uuid": "^8.3.2",
    "zone.js": "^0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "17.3.12",
    "@angular/cli": "17.3.12",
    "@angular/compiler-cli": "17.3.12",
    "@capacitor/core": "^6.1.2",
    "@faker-js/faker": "^7.4.0",
    "@playwright/test": "^1.54.2",
    "@types/jest": "^29.5.12",
    "dotenv": "^17.2.1",
    "googleapis": "^176.0.0",
    "jest": "^29.7.0",
    "jest-marbles": "^3.1.0",
    "jest-preset-angular": "^14.1.1",
    "pouchdb-adapter-memory": "^9.0.0",
    "setimmediate": "^1.0.5",
    "ts-jest": "^29.2.2",
    "typescript": "~5.4.5"
  },
  "description": "An Ionic project",
  "postinstall": "jetifier",
  "browserslist": [
    "Chrome >=79",
    "ChromeAndroid >=79",
    "Firefox >=70",
    "Edge >=79",
    "Safari >=14",
    "iOS >=14"
  ]
}
